import { fetchPlannedChanges } from '@/services/planned-changes-api.service'
import { logger } from '@/utils/logger'

// Default state
const getDefaultState = () => ({
  plannedChangesChange: [],
  plannedChangesChangeCount: [],
  plannedChangesTime: {}
})

const state = {
  plannedChangesByBoard: {}
}

const mutations = {
  setPlannedChanges(_state, { boardId, data }) {
    // Initialize state for the boardId if it doesn't exist
    if (!_state.plannedChangesByBoard[boardId]) {
      _state.plannedChangesByBoard[boardId] = getDefaultState()
    }

    // Set the data for the specific boardId
    _state.plannedChangesByBoard[boardId].plannedChangesChange = data.change || []
    _state.plannedChangesByBoard[boardId].plannedChangesChangeCount = data.changeCount || []
    _state.plannedChangesByBoard[boardId].plannedChangesTime = data.time || {}
    _state.plannedChangesByBoard[boardId].exportableData = data.exportableData || {}
  }
}

const getters = {
  getPlannedChangesChange: (_state) => (boardId) =>
    _state.plannedChangesByBoard[boardId]?.plannedChangesChange || [],
  getPlannedChangesChangeCount: (_state) => (boardId) =>
    _state.plannedChangesByBoard[boardId]?.plannedChangesChangeCount || [],
  getPlannedChangesTime: (_state) => (boardId) =>
    _state.plannedChangesByBoard[boardId]?.plannedChangesTime || {},
  getPlannedChangesExportableData: (_state) => (boardId) =>
    _state.plannedChangesByBoard[boardId]?.exportableData || {}
}

const actions = {
  async fetchPlannedChanges({ commit }, { boardId, filters = [] }) {
    try {
      const result = await fetchPlannedChanges({ boardId, filters })
      commit('setPlannedChanges', { boardId, data: result.data })
    } catch (e) {
      logger.info(e.message)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {}
}
